export default {
    defaultClinics: [
        { label: "戴麟趾康復中心 (瑪麗醫院)", value: "1", phone: "25178225", address: "香港高街一號 F", district: "西營盤" },
        { label: "東區尤德夫人那打素醫院 (瑪麗醫院)", value: "2", phone: "25957555", address: "香港柴灣樂民道 3 號", district: "柴灣" },
        { label: "貝夫人精神科中心", value: "3", phone: "21514020", address: "香港灣仔軒尼詩道 130 號修頓中心 5 樓", district: "灣仔" },
        { label: "東九龍精神科中心", value: "4", phone: "39602220", address: "九龍鑽石山斧山道 160 號東九龍分科診所第 2 期 2 樓", district: "鑽石山" },
        { label: "九龍醫院", value: "5", phone: "25178225", address: "九龍亞皆老街 147A", district: "九龍城" },
        { label: "基督教聯合醫院", value: "6", phone: "39494809", address: "九龍觀塘協和街 130 號", district: "觀塘" },
        { label: "容鳳書紀念中心 (基督教聯合醫院)", value: "7", phone: "27278406", address: "九龍觀塘茶果嶺道 79 號", district: "觀塘" },
        { label: "雅麗氏何妙齡那打素醫院", value: "8", phone: "26893266", address: "新界大埔全安路 11 號", district: "大埔" },
        { label: "葵涌醫院", value: "9", phone: "29598352", address: "新界葵涌醫院道 3-15 號", district: "葵涌" },
        { label: "沙田醫院", value: "10", phone: "39197606", address: "新界沙田馬鞍山亞公角街 33 號", district: "沙田" },
        { label: "屯門精神健康中心 (青山醫院)", value: "11", phone: "24568030", address: "新界屯門青松觀路 13 號", district: "屯門" },
        { label: "西九龍精神科中心", value: "12", phone: "29598352", address: "新界葵涌醫院道 3 至 15 號葵涌醫院 M 座 7 樓", district: "葵涌" },    
    ],
    defaultReferences: [
        {
            text: "Institute of Mental Health Castle Peak Hospital. (2011).青山醫院精神健康教育《關懷援助‧垂手可得》.Retrieved from 2 November 2021, from",
            href: "https://www3.ha.org.hk/cph/imh/doc/information/psychiatrists/L14.pdf",
        },
        {
            text: "Institute of Mental Health Castle Peak Hospital. (2021). Bipolar affective disorder. Retrieved from 2 November 2021, from",
            href: "https://www3.ha.org.hk/cph/imh/mhi/article_02_03_02.asp",
        },
        {
            text: "Institute of Mental Health Castle Peak Hospital. (2021). 藥物的認識(全集). Retrieved from 2 November 2021, from",
            href: "https://www3.ha.org.hk/cph/imh/doc/information/publications/6_07b.pdf",
        },
        {
            text: "The Mental Health Association of Hong Kong. (2020). 全港抑鬱指數調查2020 新聞發佈會. Retrieved from 2 November 2021, from",
            href: "https://www.mhahk.org.hk/index.php/20210121depressionscreening/",
        }, 
        {
            text: "Hirschfeld, et al. (2000). Development and Validation of a Screening Instrument for Bipolar Spectrum Disorder: The Mood Disorder Questionnaire. American Journal of Psychiatry 157(11), pp. 1873-1875",
        },    
    ]
}